import React, { useEffect, useMemo, useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import ResponsiveModal from '../ui/ResponsiveModal';

const QualityUserModal = ({
  isOpen,
  onClose,
  onSave,
  initialData = null,
  hotels = [],
  departments = [],
}) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [hotelId, setHotelId] = useState('');
  const [departmentId, setDepartmentId] = useState('');
  const [helpdeskUserId, setHelpdeskUserId] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isOpen) {
      document.body.style.overflow = 'unset';
      return;
    }

    document.body.style.overflow = 'hidden';
    setFirstName(initialData?.first_name || '');
    setLastName(initialData?.last_name || '');
    setHotelId(initialData?.hotel_id ? String(initialData.hotel_id) : '');
    setDepartmentId(initialData?.department ? String(initialData.department) : '');
    setHelpdeskUserId(
      initialData?.helpdesk_user != null && initialData?.helpdesk_user !== ''
        ? String(initialData.helpdesk_user)
        : ''
    );
    setError('');

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, initialData]);

  const filteredDepartments = useMemo(
    () => departments.filter((item) => !hotelId || String(item.hotel_id) === String(hotelId)),
    [departments, hotelId]
  );

  useEffect(() => {
    if (!departmentId) return;
    const selected = departments.find((item) => String(item.id) === String(departmentId));
    if (!selected) {
      setDepartmentId('');
      return;
    }
    if (hotelId && String(selected.hotel_id) !== String(hotelId)) {
      setDepartmentId('');
    }
  }, [hotelId, departmentId, departments]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!firstName.trim()) {
      setError('Ad alanı zorunludur.');
      return;
    }
    if (!lastName.trim()) {
      setError('Soyad alanı zorunludur.');
      return;
    }
    if (!departmentId) {
      setError('Departman seçimi zorunludur.');
      return;
    }

    const payload = {
      first_name: firstName.trim(),
      last_name: lastName.trim(),
      department: Number(departmentId),
    };
    if (helpdeskUserId.trim()) {
      payload.helpdesk_user = Number(helpdeskUserId.trim());
    } else {
      payload.helpdesk_user = null;
    }
    await onSave(payload);
  };

  return (
    <ResponsiveModal isOpen={isOpen} onClose={onClose} className="max-w-lg">
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
          {initialData ? 'Kullanıcı Düzenle' : 'Yeni Kullanıcı'}
        </h2>
        <button type="button" onClick={onClose} className="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">
          <XMarkIcon className="w-5 h-5" />
        </button>
      </div>

      <form onSubmit={handleSubmit} className="p-6 space-y-4">
        {error && <div className="text-sm text-red-600 dark:text-red-400">{error}</div>}
        <input
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          placeholder="Ad"
          className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-transparent text-gray-900 dark:text-gray-100 placeholder:font-semibold placeholder:text-gray-400 dark:placeholder:text-gray-500"
        />
        <input
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          placeholder="Soyad"
          className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-transparent text-gray-900 dark:text-gray-100 placeholder:font-semibold placeholder:text-gray-400 dark:placeholder:text-gray-500"
        />
        <select
          value={hotelId}
          onChange={(e) => setHotelId(e.target.value)}
          className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-transparent text-gray-900 dark:text-gray-100"
        >
          <option value="">Otel seçiniz</option>
          {hotels.map((item) => (
            <option key={item.id} value={item.id}>{item.hotel_name}</option>
          ))}
        </select>
        <select
          value={departmentId}
          onChange={(e) => setDepartmentId(e.target.value)}
          className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-transparent text-gray-900 dark:text-gray-100"
        >
          <option value="">Departman seçiniz</option>
          {filteredDepartments.map((item) => (
            <option key={item.id} value={item.id}>{item.department_name}</option>
          ))}
        </select>
        <div className="space-y-1">
          <label className="text-xs text-gray-500 dark:text-gray-400">
            Helpdesk kullanıcı ID (opsiyonel — DF yetkisi için eşleme)
          </label>
          <input
            type="number"
            min="1"
            value={helpdeskUserId}
            onChange={(e) => setHelpdeskUserId(e.target.value)}
            placeholder="Örn: 42"
            className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-transparent text-gray-900 dark:text-gray-100"
          />
        </div>
        <div className="flex justify-end gap-3">
          <button type="button" onClick={onClose} className="px-4 py-2 rounded-md border border-gray-300 dark:border-gray-600 text-sm text-gray-700 dark:text-gray-200">
            İptal
          </button>
          <button type="submit" className="px-4 py-2 rounded-md bg-blue-600 text-white text-sm">
            {initialData ? 'Güncelle' : 'Kaydet'}
          </button>
        </div>
      </form>
    </ResponsiveModal>
  );
};

export default QualityUserModal;
